<template>
  <v-container fluid style="max-width: 99% !important;">
    <v-row>
      <template v-for="(item, index) in itemsExceptionsCharts">
        <v-col cols="12" v-bind:key="index">
          <v-card v-if="viewSkeletons">
            <v-col cols="12">
              <div :class="skeletonTitle" :style="backgroundSkeleton"></div>
            </v-col>
            <v-col cols="12">
              <div :class="skeletonColumn" :style="backgroundSkeleton"></div>
            </v-col>
          </v-card>
          <v-card>
            <highcharts :id="item.title"></highcharts>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
export default {
  name: "vehiclesExceptions",
  data() {
    return {};
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.commit("setTitle", "ALERTRUCK");
    this.$store.commit("setPageHeader", [
      this.$t("titleExceptions"),
      "",
      "",
      "",
      true,
    ]);
    this.$store.commit("skeletonTitle", "outskeletonTitle");
    this.$store.commit("skeletonColumn", "outskeletonColumn");
  },
  computed: {
    ...mapState([
      "viewSkeletons",
      "itemsExceptionsCharts",
      "backgroundSkeleton",
    ]),
    skeletonTitle: {
      get: function() {
        return this.$store.state.skeletonTitle;
      },
      set: function() {},
    },
    skeletonColumn: {
      get: function() {
        return this.$store.state.skeletonColumn;
      },
      set: function() {},
    },
  },
  mounted() {
    this.$store.commit("backgroundSkeleton");
    this.getInfoChart();
  },
  methods: {
    getInfoChart() {
      this.$store.dispatch("exceptionsCharts");
    },
  },
};
</script>

<style scoped>
@import "./../assets/styles/skeletons.css";
</style>
